export default {
    formatIncludeDateString : (val) =>{
        if(val)
            return 'including the date'
        else
            return 'excluding the date'
    },
    formatIncludeNumericBetween : (val) =>{
        if(val)
            return 'including'
        else
            return 'excluding'
    },
    purchaseFormatIncludeDateString : (val, date) =>{
        if(val)
            return '"'+date+'"' + ' including the date'
        else
            return '"'+date+'"' + ' excluding the date'
    },
    updateReadableString : (model,ele,key) => {
        let index = ele.items.findIndex(x => (x[ele.item_value] ? x[ele.item_value] : x[ele.item_text] ? x[ele.item_text] : x ) == model)
        if(index != -1)
            return ele.items[index][key]
        else
            return ''
    },
    showEmailLink: (model,ele,key) => {
        let linkStr =`<a style="text-decoration:none;color:rgb(0,9,178)!important;" href=${model[key]} target="_blank">${model[key]}</a>`;
        let str = model[key].toLowerCase() === 'any' ? model[key] : linkStr
        return str;
    }
}
